// extracted by mini-css-extract-plugin
export default {"image":"C9d70h"};